<template>
  <div
    class="recommend-games-container"
    :style="{
      'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
      'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
      padding: cc.padding ? `0 ${cc.padding}px` : '0',
      background: cc.mod_bg ? `url(${cc.mod_bg})` : '',
      'background-size': 'cover',
    }"
  >
    <div
      class="games-wrapper"
      :class="{'sale-new-style': cc.style_type === 'sale_new', 'mall-style': cc.style_type === 'mall_style'}"
      :style="{background: cc.style_type === 'sale_new' ? getWrapperBg() : ''}"
    >
      <div class="sale-list">
        <div :class="`list-outer list-outer-${cpt_index} swiper-container`" ref="list-outer">
          <div class="swiper-wrapper list" :class="cc.put_type">
            <div
              class="swiper-item swiper-slide item"
              @click="toGameDetail(game)"
              v-for="(game, index) in show_list"
              :key="game.appid + index"
              v-report.exposure="getReportConfig(game)"
            >
              <div
                class="inner"
                :style="{
                  background: getCardBg(),
                }"
              >
                <div class="cover">
                  <img :src="cc.put_type === 'loop' ? game.vertical_image : game.image" alt="" />
                  <div
                    v-if="game.label && ['three', 'loop', 'col2'].includes(cc.put_type)"
                    :class="`${cc.put_type}-tag`"
                    :style="{
                      color: cc.tag_font_color,
                      background: getTagBg(),
                    }"
                  >
                    {{game.label}}
                  </div>
                </div>
                <div
                  class="body-box"
                  :style="{
                    background: gradient((cc.put_type === 'loop' ? game.vertical_image_main_color : game.image_main_color) || cc.card_color),
                  }"
                >
                  <div
                    class="name"
                    :style="{
                      color: cc.good_name_color || (['three', 'col2'].includes(cc.put_type) ? '#FFFFFF' : '#14191E'),
                    }"
                  >
                    {{ game.name }}
                  </div>
                  <div class="bottom-box">
                    <div v-if="cc.put_type == 'one'" class="one-tags">
                      <div
                        v-if="game.heybox_price.coupon_info"
                        class="one-tags-bg"
                        :style="{
                          color: cc.tag_font_color || '#FFFFFF',
                          background: cc.tag_bg_color || '#F67010',
                        }"
                      >
                        {{game.heybox_price.coupon_info.coupon_desc}}
                      </div>
                      <div v-if="game.label && !game.have_coupon_info" class="one-tags-desc" :style="{color: cc.tag_font_color || '#FFFFFF'}">{{game.label}}</div>
                      <div v-if="game.have_coupon_info && game.steam_label" class="one-tags-desc" :style="{color: cc.tag_font_color || '#FFFFFF'}">{{game.steam_label}}</div>
                    </div>
                    <div class="tags-box" v-if="cc.put_type === 'col2' && cc.style_type === 'mall_style'">
                      <div class="tag-list">
                        <template v-for="(tag, index) in game.combine_labels">
                          <div class="tag" v-if="!tag.high_light" :key="index">{{ tag.desc }}</div>
                        </template>
                      </div>
                    </div>
                    <div class="price-box">
                      <div
                        class="now-price"
                        :style="{ color: cc.price_color || (['one', 'loop'].includes(cc.put_type) ? '#FFFFFF' : '#14191E') }"
                        v-if="isHeybox(game)"
                      >
                        <span class="char">¥</span>
                        <span class="num">
                          {{ Math.round(game.heybox_price.cost_coin / 1000) }}
                        </span>
                      </div>
                      <div
                        class="original-price"
                        v-if="isHeybox(game)"
                        :style="{ color: cc.price_origin_color || (['one', 'loop'].includes(cc.put_type) ? '#C8CDD2' : '#8C9196') }"
                      >
                        ¥{{ Math.round(game.heybox_price.original_coin / 1000) }}
                      </div>
                      <div
                        class="price-off"
                        v-if="isHeybox(game) && parseFloat(game.heybox_price.discount) > 0 && cc.style_type !== 'sale_new'"
                      >
                        <span style="opacity: 0;">-{{parseFloat(game.heybox_price.discount) }}%</span>
                        <span
                          class="price-off-desc"
                          :style="{
                            color: cc.price_off_font_color || cc.tag_font_color || '#FFFFFF',
                            background: cc.price_off_bg_color || cc.tag_bg_color || '#F67010',
                          }"
                        > -{{parseFloat(game.heybox_price.discount) }}%
                        </span>
                      </div>
                    </div>
                    <div v-if="cc.put_type == 'two'" class="two-tags">
                      <div
                        v-if="game.label"
                        class="two-tags-tag"
                        :style="{
                          color: cc.tag_font_color || '#FFFFFF',
                          background: cc.tag_bg_color || '#F67010',
                        }"
                      >
                      {{game.label}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { executeProtocol, hexToRgba } from '_lib/utils';
import { ComponentCommonMixin } from '../mixin'
import Swiper, { Autoplay } from 'swiper'
import 'swiper/swiper-bundle.css'
Swiper.use(Autoplay)
export default {
  name: 'cpt-flash-sales',
  mixins: [ComponentCommonMixin],
  data() {
    return {
      active_index: 1,
      show_list: [],
      swiper: null,
      margin: '',
    }
  },
  computed: {
    gradient() {
      return (color) => {
        let gradient = ''
        switch (this.cc.put_type) {
          case 'loop':
            gradient = `linear-gradient(180deg, transparent 0,  ${color} 66.67%, ${color} 100%)`
            break
          case 'one':
            gradient = `linear-gradient(180deg, transparent 0,  ${color} 66.67%, ${color} 100%)`
            break
          case 'two':
            gradient = `linear-gradient(180deg, transparent 0,  ${color} 41.25%, ${color} 55%, transparent 55%, transparent 100%)`
        }
        return gradient
      }
    },
  },
  mounted() {
    this.show_list = this.cd.games
    setTimeout(() => {
      this.setSwiper()
    }, 0)
    this.cc.put_type = this.cc.put_type || 'loop'
  },
  methods: {
    setSwiper() {
      let swiperOption = {}
      if (['one', 'col2'].includes(this.cc.put_type)) {
        return
      } else if (this.cc.put_type == 'two') {
        swiperOption = {
          observer: true,
          observeParents: true,
          slidesPerView: 1.35,
          spaceBetween: 9,
        }
      } else if (this.cc.put_type == 'three') {
        swiperOption = {
          observer: true,
          observeParents: true,
          slidesPerView: 2.15,
          spaceBetween: 9,
        }
        if (this.cc.style_type === 'sale_new') {
          swiperOption.slidesPerView = 2.5
          swiperOption.spaceBetween = 6
          swiperOption.slidesOffsetBefore = 6
          swiperOption.slidesOffsetAfter = 6
        }
      } else {
        swiperOption = {
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
          autoplay: {
            disableOnInteraction: false, //触碰后自动轮播也不会停止
            delay: 2000,
          },
          speed: 300, //自动滑动开始到结束的时间（单位ms）
          loop: true, //开启循环
          loopedSlides: 8, //在loop模式下使用slidesPerview:'auto',还需使用该参数设置所要用到的loop个数。
          slidesPerView: 'auto', //设置slider容器能够同时显示的slides数量(carousel模式)。另外，支持'auto'值，会根据容器container的宽度调整slides数目。
          slidesPerGroup: 1,
          centeredSlides: true, //设定为true时，active slide会居中，而不是默认状态下的居左。
        }
      }
      this.swiper = new Swiper(`.list-outer-${this.cpt_index}`, swiperOption)
    },
    isHeybox(game) {
      if (game.heybox_price && Object.keys(game.heybox_price).length > 0) {
        return true
      }
      return false
    },
    getReportConfig (game) {
      return {
        path: '/game/item/show',
        type: '3',
        addition: {
          app_id: game.appid || game.steam_appid,
          sku_id: game.sku_id || '',
          act_id: this.act_id || this.querys.act_id,
          h_src: window.btoa('h5_special_recommdation_' + (this.act_id || this.querys.act_id))
        }
      }
    },
    toGameDetail(game) {
      executeProtocol({
        protocol_type: 'openGameDetail', // 协议类型
        app_id: game.appid, // 必须，游戏ID
        game_type: game.game_type, //必须，iOS 1.1.22新增
        sku_id: game.sku_id,
        h_src: window.btoa('h5_special_recommdation_' + (this.act_id || this.querys.act_id))
      })
    },
    getWrapperBg () {
      const colors = this.cc.wrapper_bg_color.split(',')
      let bg_color = ''
      let bg_img = ''
      if (colors.length === 1) bg_color = colors[0]
      else bg_color = `linear-gradient(180deg, ${colors[0]} 0%, ${colors[1]} 100%)`
      if (this.cc.wrapper_title_img) bg_img = `top / 100% auto url(${this.cc.wrapper_title_img}) no-repeat, `
      return bg_img + bg_color
    },
    getCardBg () {
      if (this.cc.card_color) {
        if (this.cc.style_type === 'sale_new') {
          return `linear-gradient(180deg, ${hexToRgba(this.cc.card_color, 0.4)} 0%, ${this.cc.card_color} 100%)`
        } else {
          return this.cc.card_color
        }
      } else {
        return ['one', 'loop'].includes(cc.put_type) ? game.image_main_color : '#FFFFFF'
      }
    },
    getTagBg () {
      if (this.cc.style_type === 'sale_new') {
        const colors = this.cc.tag_bg_color.split(',')
        if (colors.length === 1) return colors[0]
        return `linear-gradient(45deg, ${colors[0]} 0%, ${colors[1]} 100%)`
      } else {
        return this.cc.tag_bg_color
      }
    },
  },
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: "Helvetica Neue";
  src: url("../font/Helvetica-Neue.eot"); /* IE9 */
  src: url("../font/Helvetica-Neue.eot?#iefix") format("embedded-opentype"), /* IE6-IE8 */
  
  url("../font/Helvetica-Neue.woff") format("woff"), /* chrome、firefox */
  url("../font/Helvetica-Neue.ttf") format("truetype"), /* chrome、firefox、opera、Safari, Android, iOS 4.2+ */
  
  url("../font/Helvetica-Neue.svg#Helvetica-Neue") format("svg"); /* iOS 4.1- */
  font-style: normal;
  font-weight: normal;
}

.recommend-games-container {
  position: relative;
  .list-outer {
    overflow: inherit !important;
  }
  .games-wrapper {
    width: 100%;
    &.sale-new-style {
      overflow: hidden;
      padding: 40px 0 8px;
      border-radius: 8px;
      .sale-list {
        .three {
          .item {
            margin-bottom: 0;
            .inner {
              // 63 / 128 = 0.4921875
              padding-bottom: calc((100% - 12px) * 0.4921875 + 54px + 6px);
              .cover {
                width: 100%;
                height: calc(100% - 54px);
                img {
                  position: absolute;
                  left: 6px;
                  top: 6px;
                  width: calc(100% - 12px);
                  height: calc(100% - 6px);
                  object-fit: cover;
                  border-radius: 3px;
                }
                .three-tag {
                  padding: 2px 8px;
                  position: absolute;
                  left: 6px;
                  bottom: 0;
                  font-family: Helvetica Neue, PingFang SC;
                  font-size: 18px;
                  font-weight: 500;
                  line-height: 26px;
                  letter-spacing: 0px;
                  text-align: center;
                  border-radius: 6px;
                  // background: #f67010;
                  background: linear-gradient(45deg, #FF6771 0%, #F53E59 100%);
                  color: #fff;
                  transform: scale(0.5);
                  transform-origin: left bottom;
                }
              }
              .body-box {
                padding: 0 7px;
                height: 54px;
                .name {
                  margin-top: 5px;
                  font-size: 12px;
                  line-height: 17px;
                  height: auto;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                  display: block;
                }
                .bottom-box {
                  .price-box {
                    .now-price {
                      height: 21px;
                      align-items: flex-end;
                      margin-right: 4px;
                      .char {
                        font-family: PingFang SC;
                        font-size: 11px;
                        line-height: 19px;
                      }
                      .num {
                        font-family: 'Helvetica';
                        font-size: 18px;
                        line-height: 21px;
                        letter-spacing: 0.25px;
                      }
                    }
                    .original-price {
                      font-size: 11px;
                      letter-spacing: 0.25px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    &.mall-style {
      .sale-list {
        .col2 {
          .item {
            width: calc((100% - 10px) / 2);
            margin-bottom: 10px;
            border-radius: 5px;
            &:nth-child(odd) {
              margin-right: 10px;
            }
            .inner {
              padding-bottom: calc(50% + 78px);
              .cover {
                height: calc(100% - 78px);
                .col2-tag {
                  left: 8px;
                  border-radius: 2px;
                }
              }
              .body-box {
                padding: 8px;
                height: 78px;
                justify-content: flex-start;
                .name {
                  margin-top: 0;
                }
                .bottom-box {
                  flex-direction: column;
                  align-items: flex-start;
                  margin: 6px 0 0;
                  height: auto;
                  .tags-box {
                    position: relative;
                    width: 100%;
                    height: 16px;
                    overflow: hidden;
                    margin: auto 0;
                    .tag-list {
                      display: flex;
                      flex-wrap: wrap;
                      position: absolute;
                      left: 0;
                      top: 0;
                      width: 200%;
                      height: 200%;
                      transform: scale(0.5);
                      transform-origin: left top;
                      white-space: nowrap;
                      .tag {
                        position: relative;
                        height: 100%;
                        padding: 3px 8px;
                        color: #8C9196;
                        font-size: 18px;
                        line-height: 26px;
                        letter-spacing: 0.25px;
                        border-radius: 4px;
                        border: 1px solid #DADDE0;
                        & + .tag{
                          margin-left: 12px;
                        }
                      }
                    }
                  }
                  .price-box {
                    height: 16px;
                    margin-top: 6px;
                    .now-price {
                      height: 16px;
                      margin-right: 2px;
                      .char {
                        font-family: initial;
                        font-size: 10px;
                        line-height: 14px;
                        top: 1px;
                      }
                      .num {
                        font-size: 14px;
                        line-height: 16px;
                      }
                    }
                    .original-price {
                      top: 1px;
                      font-family: Helvetica;
                      line-height: 11px;
                      margin-right: 3px;
                      font-weight: 300;
                    }
                    .price-off {
                      height: 12px;
                      .price-off-desc {
                        padding: 2px 4px;
                        height: 24px;
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 20px;
                        border-radius: 4px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .sale-list {
    white-space: nowrap;
    position: relative;
    .loop {
      
      .item {
        overflow: hidden;
        position: relative;
        display: inline-block;
        width: calc((100% + 24px) / 3);
        border-radius: 4px;
        transition: transform 0.3s cubic-bezier(0.5, 0, 0.5, 1);
        transform-origin: center;
        white-space: nowrap;
        overflow: hidden;
        transform: scale(0.81);
        &.swiper-slide-active {
          transform: scale(1.1);
        }
        .inner {
          position: relative;
          width: 100%;
          padding-bottom: 151.85%;
          background: #ffffff;
          .cover {
            position: absolute;
            width: 100%;
            height: 100%;
            img {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-top-left-radius: 2px;
              border-top-right-radius: 2px;
            }
            .loop-tag {
              position: absolute;
              top: 0;
              right: 0;
              height: 14px;
              padding: 1px 4px;
              font-family: Helvetica Neue, PingFang SC;
              font-size: 9px;
              font-weight: 500;
              line-height: 12px;
              border-radius: 1px;
              color: #fff;
              background-color: #F67010;
            }
          }
          .body-box {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            width: 100%;
            height: 66%;
            position: absolute;
            bottom: 0;
            left: 0;
            padding: 0 6px;
            .name {
              margin-bottom: 4px;
              width: 100%;
              font-size: 12px;
              line-height: 16px;
              letter-spacing: -0.5px;
              text-transform: capitalize;
              color: #333;
              word-break: break-all;
              white-space: normal;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .bottom-box {
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 20px;
              margin-bottom: 6px;
              .price-box {
                display: flex;
                align-items: center;
                .now-price {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  margin-right: 3px;
                  height: 20px;
                  .char {
                    margin-right: 1px;
                    font-family: Helvetica Neue;
                    font-weight: 500;
                    font-size: 12px;
                    line-height: 20px;
                    letter-spacing: 0.25px;
                    text-transform: capitalize;
                    position: relative;
                    top: 1px;
                  }
                  .num {
                    font-family: Helvetica Neue;
                    font-size: 16px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 20px;
                  }
                }
                .original-price {
                  margin-right: 7px;
                  position: relative;
                  top: 2px;
                  font-family: Helvetica Neue;
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0px;
                  text-align: left;
                  text-decoration-line: line-through;
                  text-transform: capitalize;
                  color: #8c9196;
                }
                .price-off {
                  position: relative;
                  height: 16px;
                  color: rgba(0, 0, 0, 0);
                  font-size: 10px;
                  .price-off-desc {
                    display: flex;
                    align-items: center;
                    position: absolute;
                    left: 0;
                    top: 0;
                    padding: 0 4px;
                    height: 32px;
                    font-family: Helvetica Neue;
                    font-size: 18px;
                    font-weight: 700;
                    line-height: 22px;
                    letter-spacing: 0px;
                    text-align: center;
                    border-radius: 2px;
                    color: #ffffff;
                    background: #f67010;
                    transform: scale(0.5);
                    transform-origin: left top;
                  }
                }
              }
            }
          }
        }
      }
    }

    .one {
      display: flex;
      flex-direction: column;
      .item {
        margin-bottom: 12px;
        border-radius: 4px;
        overflow: hidden;
        .inner {
          position: relative;
          width: 100%;
          padding-bottom: 46.68%;
          background: #ffffff;
          .cover {
            position: absolute;
            width: 100%;
            height: 100%;
            img {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 88%;
              object-fit: cover;
            }
          }
          .body-box {
            position: absolute;
            bottom: 0;
            left: 0;
            padding: 0 10px;
            width: 100%;
            height: 36%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            .name {
              margin-bottom: 1px;
              height: 20px;
              width: 100%;
              font-family: PingFang SC;
              font-size: 14px;
              font-weight: 600;
              line-height: 20px;
              text-transform: capitalize;
              word-break: break-all;
              color: #333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .bottom-box {
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 14px;
              margin-bottom: 10px;
              .one-tags {
                display: flex;
                align-items: center;
                .one-tags-bg {
                  display: flex;
                  align-items: center;
                  height: 14px;
                  padding: 0 4px;
                  background: #f67010;
                  color: #fff;
                  font-family: Helvetica Neue, PingFang SC;
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 14px;
                  letter-spacing: 0px;
                }
                .one-tags-desc {
                  margin-left: 4px;
                  font-family: Helvetica Neue, PingFang SC;
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 14px;
                  letter-spacing: 0px;
                  color: #c8cdd2;
                }
              }
              .price-box {
                display: flex;
                align-items: center;
                // margin: 0 7px 7px;
                .now-price {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  margin-right: 3px;
                  height: 19px;
                  .char {
                    margin-right: 1px;
                    font-family: Helvetica Neue;
                    font-weight: 500;
                    font-size: 12px;
                    line-height: 19px;
                    letter-spacing: 0.25px;
                    text-transform: capitalize;
                    position: relative;
                    top: 1px;
                  }
                  .num {
                    font-family: Helvetica Neue;
                    font-size: 16px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 19px;
                  }
                }
                .original-price {
                  margin-right: 7px;
                  position: relative;
                  top: 2px;
                  font-family: Helvetica Neue;
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0px;
                  text-align: left;
                  text-decoration-line: line-through;
                  text-transform: capitalize;
                  color: #8c9196;
                }
                .price-off {
                  position: relative;
                  height: 16px;
                  color: rgba(0, 0, 0, 0);
                  font-size: 10px;
                  .price-off-desc {
                    display: flex;
                    align-items: center;
                    position: absolute;
                    left: 0;
                    top: 0;
                    padding: 0 4px;
                    height: 32px;
                    font-family: Helvetica Neue;
                    font-size: 18px;
                    font-weight: 700;
                    line-height: 22px;
                    letter-spacing: 0px;
                    text-align: center;
                    border-radius: 2px;
                    color: #ffffff;
                    background: #f67010;
                    transform: scale(0.5);
                    transform-origin: left top;
                  }
                }
              }
            }
          }
        }
      }
    }

    .two {
      .item {
        margin-bottom: 12px;
        border-radius: 4px;
        overflow: hidden;
        .inner {
          position: relative;
          width: 100%;
          padding-bottom: 71.96%;
          overflow: hidden;
          background: #ffffff;
          .cover {
            position: absolute;
            width: 100%;
            height: 100%;
            img {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 70.12%;
              object-fit: cover;
            }
          }
          .body-box {
            position: absolute;
            bottom: 0;
            left: 0;
            padding: 0 10px;
            width: 100%;
            height: 51.95%;
            display: flex;
            flex-direction: column;
            .name {
              padding-bottom: 10px;
              display: flex;
              align-items: flex-end;
              height: 55%;
              width: 100%;
              font-family: PingFang SC;
              font-size: 12px;
              font-weight: 500;
              line-height: 16px;
              letter-spacing: 0px;
              text-align: left;
              text-transform: capitalize;
              word-break: break-all;
              color: #333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .bottom-box {
              height: 45%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .two-tags {
                display: flex;
                align-items: center;
                .two-tags-tag {
                  display: flex;
                  align-items: center;
                  height: 14px;
                  padding: 0 4px;
                  background: #f67010;
                  color: #fff;
                  font-family: Helvetica Neue, PingFang SC;
                  font-size: 9px;
                  font-weight: 400;
                  line-height: 12px;
                  letter-spacing: 0px;
                  text-align: left;
                  border-radius: 1px;
                }
                .one-tags-desc {
                  margin-left: 4px;
                  font-family: Helvetica Neue, PingFang SC;
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 14px;
                  letter-spacing: 0px;
                  color: #c8cdd2;
                }
              }
              .price-box {
                display: flex;
                align-items: center;
                height: 20px;
                .now-price {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  margin-right: 3px;
                  height: 19px;
                  .char {
                    margin-right: 1px;
                    font-family: Helvetica Neue;
                    font-weight: 500;
                    font-size: 12px;
                    line-height: 20px;
                    letter-spacing: 0.25px;
                    text-transform: capitalize;
                    position: relative;
                    top: 1px;
                  }
                  .num {
                    font-family: Helvetica Neue;
                    font-size: 16px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 19px;
                  }
                }
                .original-price {
                  margin-right: 7px;
                  position: relative;
                  top: 2px;
                  font-family: Helvetica Neue;
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0px;
                  text-align: left;
                  text-decoration-line: line-through;
                  text-transform: capitalize;
                  color: #8c9196;
                }
                .price-off {
                  position: relative;
                  height: 16px;
                  color: rgba(0, 0, 0, 0);
                  font-size: 10px;
                  .price-off-desc {
                    display: flex;
                    align-items: center;
                    position: absolute;
                    left: 0;
                    top: 0;
                    padding: 0 4px;
                    height: 32px;
                    font-family: Helvetica Neue;
                    font-size: 18px;
                    font-weight: 700;
                    line-height: 22px;
                    letter-spacing: 0px;
                    text-align: center;
                    border-radius: 2px;
                    color: #ffffff;
                    background: #f67010;
                    transform: scale(0.5);
                    transform-origin: left top;
                  }
                }
              }
            }
          }
        }
      }
    }

    .three {
      .item {
        margin-bottom: 12px;
        border-radius: 4px;
        overflow: hidden;
        .inner {
          position: relative;
          width: 100%;
          padding-bottom: calc(50% + 75px);
          overflow: hidden;
          background: #ffffff;
          .cover {
            position: absolute;
            width: 100%;
            height: calc(100% - 75px);
            img {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .three-tag {
              padding: 1px 4px;
              position: absolute;
              left: 6px;
              bottom: -4px;
              font-family: Helvetica Neue, PingFang SC;
              font-size: 9px;
              font-weight: 400;
              line-height: 12px;
              letter-spacing: 0px;
              text-align: left;
              border-radius: 1px;
              background: #f67010;
              color: #fff;
            }
          }
          .body-box {
            position: absolute;
            bottom: 0;
            left: 0;
            padding: 0 10px;
            width: 100%;
            height: 75px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .name {
              margin-top: 6px;
              height: 36px;
              width: 100%;
              font-family: PingFang SC;
              font-size: 13px;
              font-weight: 500;
              line-height: 18px;
              letter-spacing: 0px;
              text-transform: capitalize;
              word-break: break-all;
              color: #333;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              white-space: normal;
            }
            .bottom-box {
              margin-bottom: 8px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 14px;
              .price-box {
                display: flex;
                align-items: center;
                height: 20px;
                .now-price {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  margin-right: 3px;
                  height: 19px;
                  .char {
                    margin-right: 1px;
                    font-family: Helvetica Neue;
                    font-weight: 500;
                    font-size: 12px;
                    line-height: 20px;
                    letter-spacing: 0.25px;
                    text-transform: capitalize;
                    position: relative;
                    top: 1px;
                  }
                  .num {
                    font-family: Helvetica Neue;
                    font-size: 16px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 19px;
                  }
                }
                .original-price {
                  margin-right: 7px;
                  position: relative;
                  top: 2px;
                  font-family: Helvetica Neue;
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0px;
                  text-align: left;
                  text-decoration-line: line-through;
                  text-transform: capitalize;
                  color: #8c9196;
                }
                .price-off {
                  position: relative;
                  height: 16px;
                  color: rgba(0, 0, 0, 0);
                  font-size: 10px;
                  .price-off-desc {
                    display: flex;
                    align-items: center;
                    position: absolute;
                    left: 0;
                    top: 0;
                    padding: 0 4px;
                    height: 32px;
                    font-family: Helvetica Neue;
                    font-size: 18px;
                    font-weight: 700;
                    line-height: 22px;
                    letter-spacing: 0px;
                    text-align: center;
                    border-radius: 2px;
                    color: #ffffff;
                    background: #f67010;
                    transform: scale(0.5);
                    transform-origin: left top;
                  }
                }
              }
            }
          }
        }
      }
    }

    .col2 {
      display: flex;
      flex-wrap: wrap;
      .item {
        width: calc((100% - 8px) / 2);
        margin-bottom: 12px;
        border-radius: 4px;
        overflow: hidden;
        .inner {
          position: relative;
          width: 100%;
          padding-bottom: 85%;
          overflow: hidden;
          background: #ffffff;
          .cover {
            position: absolute;
            width: 100%;
            height: 60.6%;
            img {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .col2-tag {
              padding: 1px 4px;
              position: absolute;
              left: 6px;
              bottom: -4px;
              font-family: Helvetica Neue, PingFang SC;
              font-size: 9px;
              font-weight: 400;
              line-height: 12px;
              letter-spacing: 0px;
              text-align: left;
              border-radius: 1px;
              background: #f67010;
              color: #fff;
            }
          }
          .body-box {
            position: absolute;
            bottom: 0;
            left: 0;
            padding: 0 10px;
            width: 100%;
            height: 39.4%;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            .name {
              margin-top: 6px;
              height: 18px;
              width: 100%;
              font-family: PingFang SC;
              font-size: 13px;
              font-weight: 500;
              line-height: 18px;
              letter-spacing: 0px;
              text-transform: capitalize;
              word-break: break-all;
              color: #333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .bottom-box {
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 20px;
              margin-bottom: 6px;
              .price-box {
                display: flex;
                align-items: center;
                height: 20px;
                .now-price {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  margin-right: 3px;
                  height: 19px;
                  .char {
                    margin-right: 1px;
                    font-family: Helvetica Neue;
                    font-weight: 500;
                    font-size: 12px;
                    line-height: 20px;
                    letter-spacing: 0.25px;
                    text-transform: capitalize;
                    position: relative;
                    top: 1px;
                  }
                  .num {
                    font-family: Helvetica Neue;
                    font-size: 16px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 19px;
                  }
                }
                .original-price {
                  margin-right: 7px;
                  position: relative;
                  top: 2px;
                  font-family: Helvetica Neue;
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 16px;
                  letter-spacing: 0px;
                  text-align: left;
                  text-decoration-line: line-through;
                  text-transform: capitalize;
                  color: #8c9196;
                }
                .price-off {
                  position: relative;
                  height: 16px;
                  color: rgba(0, 0, 0, 0);
                  font-size: 10px;
                  .price-off-desc {
                    display: flex;
                    align-items: center;
                    position: absolute;
                    left: 0;
                    top: 0;
                    padding: 0 4px;
                    height: 32px;
                    font-family: Helvetica Neue;
                    font-size: 18px;
                    font-weight: 700;
                    line-height: 22px;
                    letter-spacing: 0px;
                    text-align: center;
                    border-radius: 2px;
                    color: #ffffff;
                    background: #f67010;
                    transform: scale(0.5);
                    transform-origin: left top;
                  }
                }
              }
            }
          }
        }
        &:nth-child(odd) {
          margin-right: 8px;
        }
      }
    }
  }
  @keyframes scroll {
    0% {
    }
    100% {
    }
  }
}
</style>
